var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _g2, _g3, _path15, _path16, _path17, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser11White(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 800 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-reactroot": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M419.626 244.581C419.626 222.031 374.673 230.539 388.494 207.445C431.304 135.912 587.13 29.6151 624.756 60.8827C674.531 102.245 419.627 387.529 419.626 244.581Z",
    fill: "#c9c9c9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M268.923 212.064C268.951 197.147 259.922 210.839 268.923 195.545C296.8 148.171 377.919 69.6521 402.301 90.2876C434.556 117.585 268.741 306.624 268.923 212.064Z",
    fill: "#c9c9c9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.715 235.805C160.425 226.17 158.552 237.614 159.944 225.144C164.253 186.517 193.929 112.411 215.626 118.687C244.327 126.988 191.909 296.887 164.715 235.805Z",
    fill: "#c9c9c9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.691 116.556C280.615 154.429 240.718 204.922 215.917 239.884L211.648 237.77C220.001 210.996 229.459 172.645 230.837 144.406C231.18 137.362 231.017 131.02 230.233 125.685C229.444 120.319 228.054 116.16 226.086 113.327C224.185 110.588 221.745 109.069 218.534 108.821C215.183 108.562 210.713 109.668 204.866 112.886C193.528 119.125 185.34 131.474 179.706 147.933C174.086 164.356 171.125 184.537 170.004 205.918C167.762 248.671 172.892 295.741 178.322 326.019L173.575 326.871C168.1 296.35 162.92 248.894 165.187 205.666C166.32 184.057 169.32 163.383 175.143 146.371C180.952 129.397 189.691 115.731 202.541 108.66C208.788 105.222 214.232 103.651 218.905 104.012C223.718 104.383 227.414 106.781 230.048 110.575C232.617 114.275 234.164 119.266 235.005 124.984C235.85 130.733 236.007 137.411 235.655 144.641C234.471 168.906 227.491 200.212 220.313 225.548C245.294 191.473 281.104 147.238 316.334 113.092C336 94.0309 355.609 77.9915 373.141 68.6543C390.521 59.3983 406.752 56.282 418.835 64.8322C424.749 69.0171 428.193 74.3814 429.412 80.6343C430.616 86.8107 429.61 93.6445 427.052 100.803C421.948 115.081 410.403 131.369 395.839 147.824C386.782 158.056 376.486 168.432 365.701 178.524C400.088 153.955 438.181 127.854 474.847 104.657C508.09 83.6259 540.212 64.9486 567.362 51.9652C580.934 45.4744 593.316 40.3815 604.007 37.1325C614.641 33.9007 623.843 32.4158 630.957 33.3731C635.547 33.9909 639.224 35.8034 641.868 38.8077C644.485 41.7804 645.897 45.6974 646.408 50.1908C647.421 59.0932 644.978 70.9539 640.248 84.5092C630.749 111.727 611.562 147.04 589.364 182C567.146 216.991 541.818 251.776 519.94 277.964C509.006 291.052 498.896 302.038 490.439 309.837C486.214 313.734 482.353 316.88 478.972 319.1C475.671 321.267 472.522 322.759 469.785 322.926L469.491 318.112C470.909 318.025 473.169 317.14 476.325 315.068C479.401 313.049 483.045 310.095 487.169 306.292C495.41 298.691 505.37 287.881 516.239 274.871C537.967 248.863 563.173 214.25 585.292 179.415C607.43 144.549 626.38 109.608 635.694 82.9199C640.369 69.522 642.501 58.5164 641.615 50.7361C641.177 46.8881 640.022 44.0097 638.248 41.9949C636.502 40.0119 633.965 38.645 630.313 38.1536C624.24 37.3361 615.839 38.5779 605.409 41.7476C595.037 44.9 582.895 49.8833 569.443 56.3168C542.54 69.182 510.6 87.7456 477.425 108.734C421.253 144.271 361.69 186.664 317.322 219.86C309.355 226.124 301.736 231.872 294.783 236.924L291.898 233.059C298.823 227.748 306.355 222.041 314.385 216.033C340.411 195.568 370.105 169.621 392.227 144.627C406.685 128.292 417.724 112.566 422.509 99.1792C424.895 92.5047 425.66 86.5929 424.678 81.5572C423.711 76.598 421.014 72.2836 416.048 68.7696C406.372 61.9221 392.498 63.8104 375.409 72.9117C358.471 81.932 339.246 97.6028 319.691 116.556Z",
    fill: "#bebebe"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M621.92 203.813L621.921 203.789C622.187 189.431 610.19 177.365 595.45 177.365H153.444C138.729 177.365 126.68 189.415 126.68 204.129V454.277C126.68 468.991 138.729 481.041 153.444 481.041H220.878C242.029 481.041 260.545 495.238 266.035 515.663C276.085 553.054 327.228 557.76 343.933 522.832L349.83 510.501C358.44 492.499 376.621 481.041 396.576 481.041H595.157C609.871 481.041 621.92 468.991 621.92 454.277V203.813ZM153.444 174.838H595.45C611.56 174.838 624.741 188.019 624.448 203.836V454.277C624.448 470.387 611.267 483.568 595.157 483.568H396.576C377.595 483.568 360.3 494.468 352.111 511.591L346.213 523.922C328.496 560.968 274.253 555.976 263.594 516.319C258.401 496.998 240.885 483.568 220.878 483.568H153.444C137.333 483.568 124.152 470.387 124.152 454.277V204.129C124.152 188.019 137.333 174.838 153.444 174.838Z",
    fill: "#c9c9c9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M555.707 156.686H133.949C118.577 156.686 106 169.263 106 184.635V423.324C106 438.696 118.577 451.273 133.949 451.273H145.129H198.295C217.386 451.273 234.099 464.088 239.054 482.524C249.225 520.364 300.983 525.127 317.888 489.779L323.516 478.012C331.33 461.673 347.832 451.273 365.944 451.273H555.428C570.8 451.273 583.377 438.696 583.377 423.324V184.356C583.657 169.263 571.08 156.686 555.707 156.686Z",
    fill: "#ffffff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M431.615 350.376H185.38C175.877 350.376 168.051 342.55 168.051 333.047V198.051C168.051 188.549 175.877 180.723 185.38 180.723H431.615C441.117 180.723 448.943 188.549 448.943 198.051V333.047C448.943 342.83 441.397 350.376 431.615 350.376Z",
    fill: "#c9c9c9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M333.786 305.658H275.931C270.341 305.658 266.148 301.186 266.148 295.876C266.148 284.137 286.272 270.162 298.011 270.162H313.663C325.401 270.162 343.848 284.137 343.848 295.876C343.848 301.466 339.376 305.658 333.786 305.658Z",
    fill: "#ffffff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M322.607 235.785C322.607 227.12 314.781 220.133 304.999 220.133C295.216 220.133 287.391 227.12 287.391 235.785C287.391 238.3 287.391 246.964 287.391 249.48C287.391 258.144 295.216 265.132 304.999 265.132C314.781 265.132 322.607 258.144 322.607 249.48C322.607 246.964 322.607 238.3 322.607 235.785Z",
    fill: "#ffffff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M513.504 333.606H137.303C132.272 333.606 128.359 329.693 128.359 324.663C128.359 319.632 132.272 315.719 137.303 315.719H513.504C518.534 315.719 522.447 319.632 522.447 324.663C522.447 329.693 518.255 333.606 513.504 333.606Z",
    fill: "#bebebe"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.614 331.651H139.827C135.914 331.651 132.84 328.576 132.84 324.663C132.84 320.75 135.914 317.676 139.827 317.676H213.614C217.527 317.676 220.601 320.75 220.601 324.663C220.601 328.576 217.247 331.651 213.614 331.651Z",
    fill: "#F0F3F5"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M231.354 363.514H183.561C179.625 363.514 176.434 366.705 176.434 370.641C176.434 374.577 179.625 377.768 183.561 377.768H231.354C235.291 377.768 238.482 374.577 238.482 370.641C238.482 366.705 235.291 363.514 231.354 363.514Z",
    fill: "white",
    fillOpacity: 0.36
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M338.96 390.623H179.927C177.998 390.623 176.434 392.187 176.434 394.117C176.434 396.046 177.998 397.61 179.927 397.61H338.96C340.889 397.61 342.454 396.046 342.454 394.117C342.454 392.187 340.889 390.623 338.96 390.623Z",
    fill: "white",
    fillOpacity: 0.36
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M338.96 403.76H179.927C177.998 403.76 176.434 405.324 176.434 407.253C176.434 409.183 177.998 410.747 179.927 410.747H338.96C340.889 410.747 342.454 409.183 342.454 407.253C342.454 405.324 340.889 403.76 338.96 403.76Z",
    fill: "white",
    fillOpacity: 0.36
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M580.027 267.087H488.911C478.85 267.087 470.465 258.702 470.465 248.64V199.169C470.465 189.108 478.85 180.723 488.911 180.723H580.027C590.089 180.723 598.474 189.108 598.474 199.169V248.64C598.474 258.981 590.368 267.087 580.027 267.087Z",
    fill: "#bebebe"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525.802 244.169H487.232C484.716 244.169 482.48 242.212 482.48 239.417C482.48 236.902 484.437 234.666 487.232 234.666H525.802C528.318 234.666 530.554 236.622 530.554 239.417C530.554 242.212 528.318 244.169 525.802 244.169Z",
    fill: "#ffffff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M567.726 258.702H487.232C484.716 258.702 482.48 256.746 482.48 253.951C482.48 251.435 484.437 249.199 487.232 249.199H567.726C570.242 249.199 572.478 251.156 572.478 253.951C572.198 256.466 570.242 258.702 567.726 258.702Z",
    fill: "#ffffff"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.551 200.29C362.551 199.624 363.091 199.084 363.757 199.084H430.037C430.703 199.084 431.243 199.624 431.243 200.29C431.243 200.956 430.703 201.496 430.037 201.496H363.757C363.091 201.496 362.551 200.956 362.551 200.29Z",
    fill: "#bebebe"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.551 209.735C362.551 209.069 363.091 208.529 363.757 208.529H430.037C430.703 208.529 431.243 209.069 431.243 209.735C431.243 210.401 430.703 210.941 430.037 210.941H363.757C363.091 210.941 362.551 210.401 362.551 209.735Z",
    fill: "#bebebe"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M231.492 331.651H191.245C187.332 331.651 184.258 328.576 184.258 324.663C184.258 320.75 187.332 317.676 191.245 317.676H231.492C235.405 317.676 238.48 320.75 238.48 324.663C238.48 328.576 235.405 331.651 231.492 331.651Z",
    fill: "#c9c9c9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M302.725 561.366C302.725 577.413 289.716 590.422 273.669 590.422C257.622 590.422 244.613 577.413 244.613 561.366C244.613 545.319 257.622 532.311 273.669 532.311C289.716 532.311 302.725 545.319 302.725 561.366Z",
    fill: "#ffffff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: 49.4558,
    y: 275.984,
    width: 254.529,
    height: 180.743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41.692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.692
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.36 0 0 0 0 0.404445 0 0 0 0 0.6 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.0846
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd",
    x: 399.096,
    y: 192.974,
    width: 214.841,
    height: 176.271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41.692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.692
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.36 0 0 0 0 0.404445 0 0 0 0 0.6 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.0846
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd",
    x: 399.096,
    y: 207.507,
    width: 256.765,
    height: 176.271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41.692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.692
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.36 0 0 0 0 0.404445 0 0 0 0 0.6 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.0846
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1269
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser11White);
export default __webpack_public_path__ + "static/media/user-11-white.622ed15b9ab70a7dc35f428826717b88.svg";
export { ForwardRef as ReactComponent };